import { combineReducers } from 'redux';
import session from './session';
import playlists from './playlists';
import config from './config';

const musicReducer = combineReducers({
  session,
  playlists,
  config,
});

export default musicReducer;
